/**
 * Helper function to get the optimal URL with fallback priority:
 * 1. b2Url/b2CompressedUrl (first choice)
 * 2. url/compressedUrl (s3 fallback)
 */

export interface MediaFile {
  url: string
  compressedUrl?: string
  b2Url?: string
  b2CompressedUrl?: string
}

export const getOptimalUrl = (file: MediaFile, preferCompressed: boolean = true): string => {
  if (preferCompressed) {
    // Priority: b2CompressedUrl > b2Url > compressedUrl > url
    return file.b2CompressedUrl || file.b2Url || file.compressedUrl || file.url || ""
  } else {
    // Priority: b2Url > url > b2CompressedUrl > compressedUrl
    return file.b2Url || file.url || file.b2CompressedUrl || file.compressedUrl || ""
  }
}

export const getOptimalUrls = (file: MediaFile): { url: string; compressedUrl: string } => {
  return {
    url: getOptimalUrl(file, false), // Get best quality URL
    compressedUrl: getOptimalUrl(file, true) // Get best compressed URL
  }
}